<template>
  <v-dialog v-model="opened" max-width="50%" @click:outside="close">
    <v-card v-if="offer.id">
      <v-card-title class="headline">
        Status für Angebot {{ offer.id }} wählen
      </v-card-title>

      <v-card-text>
        <v-select
          v-model="nextOfferStatus"
          class="form-control"
          :items="nextStatus"
          item-value="id"
          item-text="text"
          label="nächster Status"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn color="secondary" text @click="close">
          zurück
        </v-btn>

        <v-btn color="primary" @click="save">
          speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
   props: {
      offer: {
         type: Object,
         default: () => {},
      },
      opened: {
         type: Boolean,
         required: true,
      },
      offerstatus: {
         type: Object,
         required: true,
      },
   },
   data: () => ({
      valid: false,
      nextOfferStatus: null,
   }),
   computed: {
      nextStatus () {
         if (!this.offer.offer_status[0]) {
            return this.offerstatus.filter((status) => {
               return status.status_code === 100 || status.status_code === 910 || status.status_code === 800
            })
         }
         const actualId = this.offer.offer_status[0].id

         return this.offerstatus.filter((status) => {
            return status.parent_offer_status_code_id === actualId || status.status_code === 910 || status.status_code === 800
         })
      },
   },
   methods: {
      save () {
         this.$inertia.post(`/offer/${this.offer.id}/status`, {
            nextStatusId: this.nextOfferStatus,
         })
         this.close()
      },
      close () {
         this.$emit('close', this.offer)
      },
   },
}
</script>
